import { render, staticRenderFns } from "./CambiarContraseña.vue?vue&type=template&id=21f22775"
import script from "./CambiarContraseña.vue?vue&type=script&lang=js"
export * from "./CambiarContraseña.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports